import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from '@/state/store';

// Redux hooks (keep in root as commonly used)
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// App lifecycle hooks
export * from './app';

// Auth hooks
export * from './auth';

// UI hooks
export * from './ui';

// Platform hooks
export * from './platform';

// Data fetching hooks
export * from './data';

// Analytics hooks
export * from './analytics';

// Context hooks (re-exported from @/context)
export * from '@/context';

// Domain hooks
export * from './domain';

// AI hooks
export * from './ai';